import BookingPage from './BookingPage'

export const BookingKioskPage = () => {
  return <BookingPage />
}
